// extracted by css-extract-rspack-plugin
export default {"FaqSection":"styles-module__FaqSection__wSE7u"};